import { render } from "./UserMailingDialog.vue?vue&type=template&id=40bf88a9&scoped=true"
import script from "./UserMailingDialog.vue?vue&type=script&lang=js"
export * from "./UserMailingDialog.vue?vue&type=script&lang=js"

import "./UserMailingDialog.vue?vue&type=style&index=0&id=40bf88a9&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40bf88a9"]])

export default __exports__